import { toRaw } from 'vue';

export default function useToRaw() {
  const deepToRaw = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(deepToRaw);
    }
    if (obj !== null && typeof obj === 'object') {
      const raw = toRaw(obj);
      const keys = Object.keys(raw);
      const result = {};
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        result[key] = deepToRaw(raw[key]);
      }
      return result;
    }
    return obj;
  };

  return {
    deepToRaw,
  };
}
